<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="wrap">
                <div class="content">
                    <h5 class="page-title">
                        <span class="blue title-line"></span> 申请结果
                    </h5>
                    <div class="main-box" style="padding-top:20px">
                        <div class="cnt">
                            <div class="parpers_cnt">
                                <div class="info_top">
                                    <p class="ico-wrap">
                                        <img
                                            src="@/assets/images/checktj.png"
                                            alt=""
                                        />
                                        <strong class="shz">换绑申请审核中</strong>
                                    </p>
                                    <p class="gz" >
                                        <span class="font-nowrap">
                                            请使用<strong>{{remittanceInfo.name}}</strong>的银行账户,向以下收款账户转账<strong>0.01</strong>元。
                                        </span>
                                        <br />
                                        <strong>
                                            打款时备注：该款项金额用于联合信任{{bindType == 0? "手机号" : "邮箱"}}换绑的身份验证。
                                        </strong>
                                        身份验证的转账金额，将在转账完成后的次月前两周退回到您转账的账户中。
                                    </p>
                                </div>
                                <div class="table">
                                    <dl>
                                        <dt>收款方账户名称</dt>
                                        <dd>{{remittanceInfo.tsaBankAccountName}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>收款方账号</dt>
                                        <dd>{{remittanceInfo.tsaBankNo}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>收款方开户行</dt>
                                        <dd>{{remittanceInfo.tsaBankName}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>行号</dt>
                                        <dd>{{remittanceInfo.bankCode}}</dd>
                                    </dl>
                                </div>
                                <div class="wait">
                                    <p style="color:#666">
                                        完成打款后，请耐心等待审核结果（审核时间以银行到账时间为准，一般1~3个工作日），请在30日内完成打款。<br>
                                        审核通过后将自动完成换绑，并向您的新{{bindType == 0? "手机号" : "邮箱"}}发送{{bindType == 0? "短信" : "邮件"}}通知
                                    </p>
                                </div>
                                <div class="submit">
                                    <span class="primary" @click="$router.push('/userCenter/association')">返回</span>
                                    <span class="quit" @click="cancel">取消审核</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-row>
</template>
<script>
import {bindCancelApply} from "@http/userCenter/index";
import {remittanceInfo} from '@http/user_center/realName'

export default {
    components: {},
    data() {
        return {
            bindType:'',
            remittanceInfo:{}
        };
    },
    created() {
        this.bindType = this.$route.query.type; //0手机 1邮箱
        let that = this;
        remittanceInfo().then((remittanceInfo) => {
            that.remittanceInfo=remittanceInfo;
        }).catch((err) => {
            console.log(err);
        })
    },
    mounted() {},
    computed: {
        
    },
    methods: {
        cancel() {
            let that = this;
            this.$confirm('确定取消审核吗？取消后换绑流程将终止，若需换绑需要重新提交审核。', '提示', {
                confirmButtonText: '立即取消',
                cancelButtonText: '我再想想',
                type: 'warning',
                customClass:'confirmDia'
            }).then(() => {
                bindCancelApply({type:this.bindType}).then((res) => {
                    this.$msg("取消申请成功", "success");
                    setTimeout(function() {
                        that.$router.replace({
                            path: "/userCenter/association",
                        });
                    }, 3000);
                }).catch((err) => {
                    this.$msg(err.message);
                });
            })
        },
    },
};
</script>
<style src="../../assets/css/content.css" scoped></style>
<style scoped lang='less'>

.main-box {
    width: 940px;
    margin: 0 auto;
}
.cnt {
    text-align: center;
}
.parpers_cnt {
    text-align: center;
    width: 100%;
    background: #fff;
    padding: 1px 31px;
    margin-top: 24px;
    box-sizing: border-box;
}
.ico-wrap {
    margin-bottom: 30px;
}

.submit {
    margin-top: 32px;
    text-align: center;
}
.submit {
    span{
        display: inline-block;
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #10A0E9;
        font-size: 16px;
        border-radius: 5px;
        border:1px solid #10A0E9;
        cursor: pointer;
    }
    .primary{
        background:#10A0E9;
        color: #fff;
        margin-bottom: 20px;
        margin-right: 50px;
        opacity: .7;
        &:hover{
            opacity: 1;
        }
    }
    .quit{
        color:#10A0E9;
        &:hover{
            background: #10a1e91d;
        }
    }
}
.bold {
    color: #333;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
}
.thin {
    font-size: 14px;
    color: #999;
}
.table {
    width: 100%;
    margin-top: 29px;
    box-sizing: border-box;
    padding: 10px 20%;
    background: #fafafa;
    border: 1px solid #e1e6eb;
}
.table dl {
    overflow: hidden;
    border-bottom: 1px dashed #e1e6eb;
    padding: 20px 0 20px;
    font-size: 14px;
    color: #333;
}
.table dl:last-child {
    border: none;
}
.table dt {
    float: left;
}
.table dd {
    float: right;
}
.btns {
    width: 100px;
    padding-top: 14px;
}
.goback {
    display: inline-block;
    width: 94px;
    height: 28px;
    font-size: 14px;
    border-radius: 28px;
    cursor: pointer;
    line-height: 28px;
    background: #fff;
    color: #333;
    border: 1px solid #3080fe;
    margin-top: 12px;
}
.parpers_cnt p{
  margin: 1px 0 20px;
  font-size: 14px;
  color:#333;
}
.parpers_cnt .gz {
    font-size: 14px;
    line-height: 28px;
    font-weight: 500;
    color: #333;
    width: 1400px;
    margin-left: -261px;
}
.gz{
    strong{
        color: #F09135;
    }
}
.wait {
    color: #666;
    text-align: center;
    font-size: 15px;
    margin: 38px 0 40px;
}
.shz{
    display: block;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px !important;
}

.reasons{
  font-size: 14px;
  color:#666;
}
.goattestation span{
  margin-top: 20px;
  display: inline-block;
  width: 110px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #3F7DF7;
  color:#3F7DF7;
  border-radius: 33px;
  cursor: pointer;
}
.goattestation span:hover{
  color:#fff;
  background:#3F7DF7;
}
.font-nowrap{
    white-space: nowrap;
}
.cancel{
    color:#3f7df7;
    cursor: pointer;
}
.cancel:hover{
    color:#79a9f8;
}
</style>
<style lang="less">
.confirmDia{
    .el-message-box__status{
        top:0 !important;
        transform:translateY(0) !important;
    }
}
</style>
